import { useTypeDefinition } from './type-definition-context';
import { TypeDefinitionKey } from './type-definition-key';
import { TypeDefinitionObject } from './type-definition-object';
import { TypeDefinitionToken } from './type-definition-token';

/** Renders a type definition of function arguments or object properties with syntax highlighting. */
export const TypeDefinitionPair = () => {
  const props = useTypeDefinition();
  const {
    entity,
    language,
    passHrefs,
    syntax
  } = props;
  const expanded = props.expanded && (entity.unwrap || entity.expanded);
  let constant = '';
  let type = entity.type ?? '';
  const url = passHrefs ? entity.url : undefined;
  const {
    optional
  } = entity;
  if (language === 'ruby' && syntax !== 'list') {
    type = optional ? `${type}?` : type;
  }
  if (language === 'python') {
    type = optional ? `${type} | None` : type;
  }
  if (language === 'php') {
    if (isConstant(type)) {
      constant = type;
      type = 'string';
    }
    type = optional ? `?${type}` : type;
    if (syntax === 'object') {
      return <>
          <TypeDefinitionKey /> <span className="token operator">{'=>'}</span>{' '}
          <TypeDefinitionToken href={url} token={type} />
          {expanded && ' '}
          {expanded && <TypeDefinitionObject />}
        </>;
    }
    if (expanded) {
      return <>
          <TypeDefinitionToken href={url} token={type} /> <TypeDefinitionKey />{' '}
          <TypeDefinitionObject />
        </>;
    }
    return <>
        <TypeDefinitionToken href={url} token={type} /> <TypeDefinitionKey />
        {constant && ' '}
        {constant && <TypeDefinitionToken token={constant} />}
      </>;
  }
  if (language === 'dotnet') {
    if (isConstant(type)) {
      constant = type;
      type = 'string';
    }
    type = optional ? `${type}?` : type;
    if (expanded) {
      return <>
          <TypeDefinitionToken href={url} token={type || entity.key} />{' '}
          <TypeDefinitionKey /> <TypeDefinitionObject />
        </>;
    }
    return <>
        <TypeDefinitionToken href={url} token={type} /> <TypeDefinitionKey />
        {constant && ' '}
        {constant && <TypeDefinitionToken token={constant} />}
      </>;
  }
  if (language === 'java') {
    if (isConstant(type)) {
      constant = type;
      type = 'String';
    }
    type = optional ? `${type}?` : type;
    if (expanded) {
      return <>
          <TypeDefinitionToken href={url} token={type || entity.key} />{' '}
          <TypeDefinitionKey /> <TypeDefinitionObject />
        </>;
    }
    return <>
        <TypeDefinitionToken href={url} token={type} /> <TypeDefinitionKey />
        {constant && ' '}
        {constant && <TypeDefinitionToken token={constant} />}
      </>;
  }
  if (language === 'go') {
    return <>
        <TypeDefinitionKey />{' '}
        <TypeDefinitionToken className="token go" href={url} token={type} />
        {expanded && <TypeDefinitionObject />}
      </>;
  }
  if (expanded) {
    return <>
        <TypeDefinitionKey /> <TypeDefinitionObject />
      </>;
  }
  return <>
      <TypeDefinitionKey data-sentry-element="TypeDefinitionKey" data-sentry-source-file="type-definition-pair.tsx" /> <TypeDefinitionToken href={url} token={type} data-sentry-element="TypeDefinitionToken" data-sentry-source-file="type-definition-pair.tsx" />
    </>;
};
const isConstant = (str: string) => /^'|".+?'|"$/.test(str);